<mat-toolbar class="mat-elevation-z2">
  <mat-toolbar-row fxLayout="row">
    <span>
      <img alt="Brand" src="favicon.ico" style="padding-right: 15px" />
    </span>
    <span style="padding-right: 15px">Momentum Wealth International</span>
    <button mat-button (click)="navigateHome()" *ngIf="mayShowHome$()">
      Home
    </button>
    <button
      mat-button
      *ngIf="mayShow$(['admin-manage-users', 'manage-news', 'admin-audit-log'])"
      [routerLinkActive]="['active']"
      [matMenuTriggerFor]="manageMenu"
    >
      <span>Manage</span><mat-icon iconPositionEnd aria-hidden="false" aria-label="User drop-down icon">arrow_drop_down</mat-icon>
      <mat-menu #manageMenu="matMenu">
        <a id="manageUsers"
          mat-button class="font-size-m"
          *ngIf="mayShow$(['admin-manage-users'])"
          [routerLink]="['/admin/manage-users']"
          [routerLinkActive]="['active']"
        >Manage Users</a>
        <a id="manageUsersList"
           mat-button class="font-size-m"
           *ngIf="mayShow$(['admin-manage-users'])"
           [routerLink]="['/admin/manage-users-list']"
           [routerLinkActive]="['active']"
        >Manage Users List</a>
        <a id="manageLatestNews"
          mat-button class="font-size-m"
          *ngIf="mayShow$(['manage-news'])"
          [routerLink]="['/news/manage-news']"
          [routerLinkActive]="['active']"
        >Manage Latest News</a>
        <a id="manageDocuments"
          mat-button class="font-size-m"
          *ngIf="mayShow$(['admin-audit-log'])"
          [routerLink]="['/admin/manage-documents']"
          [routerLinkActive]="['active']"
        >Manage Documents</a>
        <a id="digiHowVideos"
          mat-button class="font-size-m"
          *ngIf="mayShow$(['admin-audit-log'])"
          [routerLink]="['/admin/digihow-videos']"
          [routerLinkActive]="['active']"
        >Manage DigiHow Videos</a>
        <a id="digiKnowVideos"
          mat-button class="font-size-m"
          *ngIf="mayShow$(['admin-audit-log'])"
          [routerLink]="['/admin/digiknow-videos']"
          [routerLinkActive]="['active']"
        >Manage DigiKnow Videos</a>
      </mat-menu>
    </button>
    <a id="instructions"
      mat-button class="font-size-m"
      *ngIf="mayShow$(['instruction'])"
      [routerLink]="['/instruction/approve-instructions']"
      [routerLinkActive]="['active']"
    >
      Instructions
    </a>
    <a id="feeWithDrawalUploads"
      mat-button class="font-size-m"
      *ngIf="mayShow$(['fee-upload'])"
      [routerLink]="['/fee-upload/approve-fee-upload']"
      [routerLinkActive]="['active']"
    >
      Fee Withdrawal Uploads
    </a>
    <a id="news"
      mat-button class="font-size-m"
      *ngIf="mayShow$(['news'])"
      [routerLink]="['/general/news']"
      [routerLinkActive]="['active']"
    >News</a
    >
    <a id="auditLog"
      mat-button class="font-size-m"
      *ngIf="mayShow$(['admin-audit-log'])"
      [routerLink]="['/admin/audit-log']"
      [routerLinkActive]="['active']"
      >Audit Log</a
    >
    <a id="viewReports"
      mat-button class="font-size-m"
      *ngIf="mayShow$(['admin-audit-log'])"
      [routerLink]="['/admin/view-reports']"
      [routerLinkActive]="['active']"
    >View Reports</a
    >
    <a id="help" class="font-size-m"
      mat-button
      [routerLink]="['/general/help']"
      [routerLinkActive]="['active']"
      >Help</a
    >

    <div fxFlex style="flex-grow: 8"></div>

    <mat-select
      placeholder="Role"
      [disabled]="hasSelectedRole()"
      [(value)]="role"
      class="role-select font-size-m"
      (selectionChange)="roleChanged()"
      *ngIf="userTypeMap.length !== 0"
    >
      <mat-option *ngFor="let role of userTypeMap" [value]="role.key"
        >{{role.name === 'Advisor' ? 'Adviser' : (role.name === 'Brokerage' ? 'Intermediary Firm' : role.name)}}</mat-option
      >
    </mat-select>
    <button class="font-size-m"
      mat-button
      id="navbar-profile-button"
      [routerLinkActive]="['active']"
      [matMenuTriggerFor]="userMenu"
    >
      <span>{{ username }}</span>
      <mat-icon iconPositionEnd aria-hidden="false" aria-label="User drop-down icon"
        >arrow_drop_down</mat-icon>
      <mat-menu #userMenu="matMenu">
        <a
          mat-menu-item
          [routerLink]="['/profile/detail']"
          [routerLinkActive]="['active']"
          >Profile</a
        >
        <a
          mat-menu-item
          *ngIf="mayShow$(['manage-users'])"
          [routerLink]="['/profile/user-list']"
          [routerLinkActive]="['active']"
          >Manage Users</a
        >
        <button
          id="navbar-logout-button"
          mat-menu-item (click)="logout()">Logout</button>
      </mat-menu>
    </button>
  </mat-toolbar-row>
</mat-toolbar>
<mat-progress-bar
  mode="indeterminate"
  style="margin-top: 1px;"
  *ngIf="loading"
></mat-progress-bar>
